import * as React from 'react';

// Internal Import
import { stringAvatar } from '../utils/string-avatar';
import { ResponseLoginData, defaultLoginData } from '../modules/types/login.type';

// Extenal Import
import { common } from "@mui/material/colors";
import { useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { ReactSession } from 'react-client-session';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import GradeRoundedIcon from '@mui/icons-material/GradeRounded';
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import AccountTreeRoundedIcon from '@mui/icons-material/AccountTreeRounded';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';

import {
    Box,
    List,
    Link,
    Menu,
    Stack,
    AppBar,
    Avatar,
    Button,
    Drawer,
    Divider,
    Toolbar,
    Tooltip,
    ListItem,
    MenuItem,
    IconButton,
    Typography,
    ListItemText,
    ListItemButton,
    ListItemIcon,
} from '@mui/material';
import { deep } from '../theme/colors';


const pages = ["home", "products", "promotions"];
const settings = ['account', 'favorites','transactions', 'logout'];

export interface AppBarProps {}
export const AppBarComponent: React.FC<AppBarProps> = ({ }) => {

    let navigate = useNavigate();

    let userAuth: ResponseLoginData = defaultLoginData;
    if (ReactSession.get("user_auth") == true) { userAuth = ReactSession.get("user_data"); }


    const [scrolled, setScrolled] = React.useState<boolean>(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 50) {
            setScrolled(true)
        }
        else if (scrolled <= 50) {
            setScrolled(false)
        }
    };

    window.addEventListener('scroll', toggleVisible);

    const [indexMouseEnter, setIndexMouseEnter] = React.useState<number>(0);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const handleUserMenu = (item: string) => {
        if (item == "logout") {
            ReactSession.set("user_auth", false);
            ReactSession.set("user_data", defaultLoginData);
            ReactSession.set("user_token", "");
            handleCloseUserMenu();
            setMobileOpen(false);
            window.location.reload();
            return;
        }
        navigate(`/${item}`);
        handleCloseUserMenu();
    }
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const [mobileOpen, setMobileOpen] = React.useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const handleToLogin = () => {
        navigate('/login');
    }

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <img
                src='/assets/logos/ciputra.png'
                style={{
                    height: 16,
                    marginTop: 32,
                    marginBottom: 32,
                    objectFit: 'contain',
                }}
            />
            <Divider />

            {userAuth.fullname != "" && (
                <Button fullWidth variant='contained' sx={{
                    py: 4,
                    borderRadius: 0,
                    color: '#ffffff',
                    fontSize: '0.8em',
                    fontWeight: '500',
                    fontFamily: 'Montserrat',
                }}>{userAuth.fullname}</Button>
            )}

            <List>
                {settings.map((item) => item != 'logout' && (
                    <ListItem key={item} disablePadding>
                        <ListItemButton onClick={() => navigate(`/${item}`)}>
                            <ListItemIcon>
                                {item == 'account' && ( <AccountBoxRoundedIcon /> )}
                                {item == 'favorites' && ( <GradeRoundedIcon /> )}
                                {item == 'transactions' && ( <ReceiptLongRoundedIcon /> )}
                            </ListItemIcon>
                            <ListItemText sx={{ textTransform: 'capitalize' }} primary={item} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>

            <Divider />

            <List>
                {pages.map((item) => (
                    <ListItem key={item} disablePadding>
                        <ListItemButton onClick={() => navigate(`/${item}`)}>
                            <ListItemIcon>
                                {item == 'home' && ( <HomeRoundedIcon /> )}
                                {item == 'products' && ( <AccountTreeRoundedIcon /> )}
                                {item == 'promotions' && ( <LocalOfferRoundedIcon /> )}
                            </ListItemIcon>
                            <ListItemText sx={{ textTransform: 'capitalize' }} primary={item} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <Button
                fullWidth
                size="small"
                variant='outlined'
                onClick={userAuth.fullname != "" ? () => handleUserMenu('Logout') : handleToLogin}
                sx={{ width: '82%', mt: 5, padding: 1, }}
            >
                <img
                    src='/assets/icons/login.png'
                    style={{
                        height: 20,
                        objectFit: 'contain'
                    }}
                />
                <Typography
                    variant="body2"
                    color={deep.main}
                    sx={{
                        paddingLeft: 2,
                        fontWeight: '500',
                        fontFamily: 'Montserrat',
                        textTransform: 'capitalize',
                    }}
                >
                    {userAuth.fullname != "" ? "Logout" : "Login"}
                </Typography>
            </Button>
        </Box>
    );

    return (
        <Box sx={{ marginBottom: 4 }}>
            <AppBar position="fixed" component='nav' style={{
                background: common.white,
                boxShadow: scrolled?"0 3px 5px rgba(57, 63, 72, 0.3":"unset"
            }}>
                <Toolbar disableGutters sx={{
                    width: { xs: '96%', sm: '94%' },
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    justifyContent: 'space-between',
                }}>
                    <Link href='/'>
                        <Box
                            component="img"
                            alt="Logo Ciputra."
                            src="/assets/logos/ciputra.png"
                            sx={{ height: { xs: 18, md: 28, lg: 32 } }}
                        />
                    </Link>

                    <>
                        <Stack 
                            flex={1}
                            direction={'row'}
                            display={{xs: 'none', md: 'flex'}}
                        >
                            <Box sx={{
                                flexGrow: 1,
                                paddingRight: '7em',
                                alignItems: 'center',
                                marginTop: "-0.5em",
                                justifyContent: 'right',
                                display: { xs: 'none', md: 'flex', lg: 'flex' },
                            }}>
                                {pages.map((item, index) => (
                                    <div
                                        onClick={() => navigate(`/${item}`)}
                                        style={{ paddingLeft: '2.4em', cursor: 'pointer' }}
                                        onMouseLeave={() => setIndexMouseEnter(0)}
                                        onMouseEnter={() => setIndexMouseEnter(index + 1)}
                                    >
                                        <Typography
                                            key={item}
                                            style={{
                                                fontSize: 14,
                                                color: '#333333',
                                                fontFamily: 'Roboto',
                                                textTransform: 'capitalize',
                                                fontWeight: indexMouseEnter == (index + 1) ? "bold" : "500"
                                            }}
                                            sx={{ my: 2, color: 'white' }}
                                        >
                                            {item}
                                        </Typography>
                                        <hr style={{
                                            marginTop: -14,
                                            border: indexMouseEnter == (index + 1)
                                                ? '1px solid #008060'
                                                : '1px solid transparent'
                                        }} />
                                    </div>
                                ))}
                            </Box>
                            <Box sx={{ display: { xs: 'none', sm: 'none', md: 'flex', lg: 'flex' } }}>
                                <Tooltip title={userAuth.fullname !== '' ? "Your Profile" : "Login"}>
                                    {userAuth.fullname !== '' ? (
                                        <>
                                            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                                <Avatar
                                                    alt={"Your profile"}
                                                    {...stringAvatar(userAuth.fullname)}
                                                />
                                            </IconButton>
                                            <Menu
                                                sx={{ mt: '45px' }}
                                                id="menu-appbar"
                                                anchorEl={anchorElUser}
                                                anchorOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                keepMounted
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                open={Boolean(anchorElUser)}
                                                onClose={handleCloseUserMenu}
                                            >
                                                {settings.map((setting) => (
                                                    <MenuItem key={setting} onClick={() => handleUserMenu(setting)}>
                                                        <Typography sx={{
                                                            textAlign: 'center',
                                                            textTransform: 'capitalize'
                                                        }}>{setting}</Typography>
                                                    </MenuItem>
                                                ))}
                                            </Menu>
                                        </>
                                    ) : (
                                        <div onClick={handleToLogin} style={{ cursor: 'pointer' }}>
                                            <Stack 
                                                direction={'row'}
                                                alignItems={'center'}
                                                justifyContent={'center'}
                                            >
                                                <img
                                                    src='/assets/icons/login.png'
                                                    style={{ height: 20, objectFit: 'contain' }}
                                                />
                                                <Typography
                                                    style={{
                                                        fontSize: 12,
                                                        color: '#333333',
                                                        cursor: 'pointer',
                                                        fontWeight: '500',
                                                        marginLeft: '0.8em',
                                                        fontFamily: 'Roboto',
                                                    }}
                                                    sx={{ my: 2, color: 'white', display: 'block' }}
                                                >Login</Typography>
                                            </Stack>
                                        </div>
                                    )}
                                </Tooltip>
                            </Box>
                        </Stack>
                        <Stack display={{sm: 'flex', md: 'none'}}>
                            <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="open drawer"
                                onClick={handleDrawerToggle}
                            >
                                <MenuIcon style={{ fill: '#008060' }} />
                            </IconButton>
                        </Stack>
                    </>
                </Toolbar>
            </AppBar>
            <Drawer
                anchor='right'
                open={mobileOpen}
                variant="temporary"
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { md: 'block', lg: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
                }}
            >
                {drawer}
            </Drawer>
        </Box>
    );
}